import { render, staticRenderFns } from "./BetgameEditColors.vue?vue&type=template&id=6147767e&scoped=true"
import script from "./BetgameEditColors.vue?vue&type=script&lang=js"
export * from "./BetgameEditColors.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditColors.vue?vue&type=style&index=0&id=6147767e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147767e",
  null
  
)

export default component.exports